module.exports = __webpack_public_path__ + "static/media/onet-world.a41ffed8.png";